import type { BlockConfig } from "@/types/blocks.types";

// CONVENTION: Each DR block name must include BLOCK_PREFIX so the name is
// registered in ODA as-is, with no transformation at insertion time.
// Use BlockLibrary.getBlockConfigName() to strip the prefix for display.
export const BLOCK_PREFIX = "__DR_DRAWING_BLOCK_";

// scale must be 1.
export const DR_BLOCKS: BlockConfig[] = [
  {
    name: `${BLOCK_PREFIX}Rejet`,
    scale: 1,
    geometries: [
      {
        type: "circle",
        center: [-1, 0, 0],
        radius: 0.5,
      },
      {
        type: "circle",
        center: [-1, 0, 0],
        radius: 0.05,
        filled: true,
      },
      {
        type: "circle",
        center: [1, 0, 0],
        radius: 0.5,
      },
      {
        type: "polyline",
        points: [
          [0.5, 0, 0],
          [1.5, 0, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1, 0.5, 0],
          [1, -0.5, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Végétation`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1, 0, 0],
          [-1, 0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1, 0, 0],
          [-1.2, 0.2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1, 0, 0],
          [-0.8, 0.2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1, 0, 0],
          [1, 0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1, 0, 0],
          [1.2, 0.2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1, 0, 0],
          [0.8, 0.2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0, 1, 0],
          [0, 1.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0, 1, 0],
          [0.2, 1.2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0, 1, 0],
          [-0.2, 1.2, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Humidité`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-0.6, -0.4, 0],
          [0.4, 0.6, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.4, -0.6, 0],
          [0.6, 0.4, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.6, 0.4, 0],
          [0.4, -0.6, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.4, 0.6, 0],
          [0.6, -0.4, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}AAO`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1, 0.3, 0],
          [-1, -0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1, 0.3, 0],
          [1, -0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1, 0, 0],
          [1, 0, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Eclat`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1.2, 0, 0],
          [-0.8, 0.2, 0],
          [-0.6, 0.8, 0],
          [-0.4, 0.4, 0],
          [0, 0.8, 0],
          [0.3, 0.4, 0],
          [0.6, 0.8, 0],
          [0.8, 0.5, 0],
          [1.2, 0, 0],
          [0.8, -0.5, 0],
          [0.6, -0.8, 0],
          [0.3, -0.4, 0],
          [0, -0.8, 0],
          [-0.4, -0.4, 0],
          [-0.6, -0.8, 0],
          [-0.8, -0.2, 0],
          [-1.2, 0, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Eclat avec acier apparent`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1.2, 0, 0],
          [-0.8, 0.2, 0],
          [-0.6, 0.8, 0],
          [-0.4, 0.4, 0],
          [0, 0.8, 0],
          [0.3, 0.4, 0],
          [0.6, 0.8, 0],
          [0.8, 0.5, 0],
          [1.2, 0, 0],
          [0.8, -0.5, 0],
          [0.6, -0.8, 0],
          [0.3, -0.4, 0],
          [0, -0.8, 0],
          [-0.4, -0.4, 0],
          [-0.6, -0.8, 0],
          [-0.8, -0.2, 0],
          [-1.2, 0, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.7, 0.3, 0],
          [-0.7, -0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.7, 0.3, 0],
          [0.7, -0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.7, 0, 0],
          [0.7, 0, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Amorce d'éclat`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1, -0.5, 0],
          [-1, 0.5, 0],
          [1, 0.5, 0],
          [1, -0.5, 0],
          [-1, -0.5, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1, -0.5, 0],
          [1, 0.5, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1, -0.5, 0],
          [-1, 0.5, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Eclat 2`,
    scale: 1,
    geometries: [
      {
        type: "circle",
        center: [0, 0, 0],
        radius: 0.6,
      },
      {
        type: "circle",
        center: [0, 0, 0],
        radius: 0.4,
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Eclat 2 avec acier apparent`,
    scale: 1,
    geometries: [
      {
        type: "circle",
        center: [0, 0, 0],
        radius: 0.6,
      },
      {
        type: "circle",
        center: [0, 0, 0],
        radius: 0.4,
      },
      {
        type: "polyline",
        points: [
          [-0.7, 0.3, 0],
          [-0.7, -0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.7, 0.3, 0],
          [0.7, -0.3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.7, 0, 0],
          [0.7, 0, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Rouille`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-0.6, 0.4, 0],
          [-0.9, -0.4, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.3, 0.4, 0],
          [-0.6, -0.4, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0, 0.4, 0],
          [-0.3, -0.4, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.3, 0.4, 0],
          [0, -0.4, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.6, 0.4, 0],
          [0.3, -0.4, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.9, 0.4, 0],
          [0.6, -0.4, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Stalactite`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [0, 0.5, 0],
          [0, 0.4, 0],
          [-0.2, 0.3, 0],
          [0.2, 0.1, 0],
          [-0.1, -0.1, 0],
          [0, -0.3, 0],
          [0, -0.4, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Point`,
    scale: 1,
    geometries: [
      {
        type: "circle",
        center: [0, 0, 0],
        radius: 0.3,
        filled: true,
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Flèche`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1, 0.4, 0],
          [0.4, 0.4, 0],
          [0.4, 0.8, 0],
          [1, 0, 0],
          [0.4, -0.8, 0],
          [0.4, -0.4, 0],
          [-1, -0.4, 0],
          [-1, 0.4, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Concrétion-sèche-1`,
    scale: 1,
    geometries: [
      {
        type: "circle",
        center: [-0.5, -0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "circle",
        center: [0.5, -0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "circle",
        center: [0.5, 0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "circle",
        center: [-0.5, 0.5, 0],
        radius: 0.5,
        filled: false,
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Concrétion-humide-1`,
    scale: 1,
    geometries: [
      {
        type: "circle",
        center: [-0.5, -0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "circle",
        center: [0.5, -0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "circle",
        center: [0.5, 0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "circle",
        center: [-0.5, 0.5, 0],
        radius: 0.5,
        filled: false,
      },
      {
        type: "polyline",
        points: [
          [-0.25, -0.5, 0],
          [-0.35, -1, 0],
          [-0.15, -2, 0],
          [-0.35, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.75, -0.5, 0],
          [-0.85, -1, 0],
          [-0.65, -2, 0],
          [-0.85, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.25, -0.5, 0],
          [0.15, -1, 0],
          [0.35, -2, 0],
          [0.15, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.75, -0.5, 0],
          [0.65, -1, 0],
          [0.85, -2, 0],
          [0.65, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1.25, 0, 0],
          [1.15, -0.5, 0],
          [1.35, -1.5, 0],
          [1.15, -2.5, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1.75, 0.5, 0],
          [1.65, 0, 0],
          [1.85, -1, 0],
          [1.65, -2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1.25, 0, 0],
          [-1.15, -0.5, 0],
          [-1.35, -1.5, 0],
          [-1.15, -2.5, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1.75, 0.5, 0],
          [-1.65, 0, 0],
          [-1.85, -1, 0],
          [-1.65, -2, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Stalactite-sèche-1`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1, 1, 0],
          [1, 1, 0],
          [0.25, 0, 0],
          [0, -1, 0],
          [-0.25, 0, 0],
          [-1, 1, 0],
        ],
      },
    ],
    attributes: [],
  },
  {
    name: `${BLOCK_PREFIX}Stalactite-humide-1`,
    scale: 1,
    geometries: [
      {
        type: "polyline",
        points: [
          [-1, 1, 0],
          [1, 1, 0],
          [0.25, 0, 0],
          [0, -1, 0],
          [-0.25, 0, 0],
          [-1, 1, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.25, -0.5, 0],
          [-0.35, -1, 0],
          [-0.15, -2, 0],
          [-0.35, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-0.75, -0.5, 0],
          [-0.85, -1, 0],
          [-0.65, -2, 0],
          [-0.85, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.25, -0.5, 0],
          [0.15, -1, 0],
          [0.35, -2, 0],
          [0.15, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [0.75, -0.5, 0],
          [0.65, -1, 0],
          [0.85, -2, 0],
          [0.65, -3, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1.25, 0, 0],
          [1.15, -0.5, 0],
          [1.35, -1.5, 0],
          [1.15, -2.5, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [1.75, 0.5, 0],
          [1.65, 0, 0],
          [1.85, -1, 0],
          [1.65, -2, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1.25, 0, 0],
          [-1.15, -0.5, 0],
          [-1.35, -1.5, 0],
          [-1.15, -2.5, 0],
        ],
      },
      {
        type: "polyline",
        points: [
          [-1.75, 0.5, 0],
          [-1.65, 0, 0],
          [-1.85, -1, 0],
          [-1.65, -2, 0],
        ],
      },
    ],
    attributes: [],
  },
];
